module.exports = __webpack_public_path__ + "static/media/offers.88b0de0d.svg";